import { call, put, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut, HTTP_METHOD } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { Staatsbuergerschaften } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutActions } from '../checkout.actions';

export enum StaatsbuergerschaftenListRequestActions {
  STAATSBUERGERSCHAFTENLISTE_REQUEST_SUCCESSFUL = 'STAATSBUERGERSCHAFTENLISTE_REQUEST_SUCCESSFUL',
  STAATSBUERGERSCHAFTENLISTE_REQUEST_FAILED = 'STAATSBUERGERSCHAFTENLISTE_REQUEST_FAILED',
}

export const URL_STAATSBUERGERSCHAFTENLSITE = '/privatschutz/api/staatsbuergerschaften';

export function* watchStaatsbuergerschfatenListRequest() {
  yield takeEvery(
    CheckoutActions.STAATSBUERGERSCHAFTEN_REQUESTED,
    safeSaga(getStaatsbuergerschaftenListSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    StaatsbuergerschaftenListRequestActions.STAATSBUERGERSCHAFTENLISTE_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* getStaatsbuergerschaftenListSaga() {
  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP,
      method: HTTP_METHOD.GET,
      body: '',
      url: URL_STAATSBUERGERSCHAFTENLSITE,
      successEvent:
        StaatsbuergerschaftenListRequestActions.STAATSBUERGERSCHAFTENLISTE_REQUEST_SUCCESSFUL,
      errorEvent: StaatsbuergerschaftenListRequestActions.STAATSBUERGERSCHAFTENLISTE_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: AnyAction) {
  const list = (successAction.payload as Staatsbuergerschaften).staatsbuergerschaften;
  yield put({
    type: CheckoutActions.STAATSBUERGERSCHAFTEN_RECEIVED,
    payload: list,
  });
}
